import { render, staticRenderFns } from "./ProductCustomisationVariationAlphanumericInput.vue?vue&type=template&id=5d1a6ace&scoped=true&"
import script from "./ProductCustomisationVariationAlphanumericInput.vue?vue&type=script&lang=js&"
export * from "./ProductCustomisationVariationAlphanumericInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a6ace",
  null
  
)

export default component.exports